module.exports = __webpack_public_path__ + "media/bootstrap-icons/translate-dc00078e.svg";